const common = {
  "site.name": "成91平台",
  "site.tagline": "探索成91，开启全新体验",
  "nav.home": "首页",
  "nav.categories": "分类浏览",
  "nav.about": "关于我们",
  "nav.articles": "文章资讯",
  "breadcrumb.home": "首页",
  "breadcrumb.categories": "分类",
  "breadcrumb.articles": "文章",
  "breadcrumb.about": "关于我们",
  "footer.copyright": "© 2026 成91平台 版权所有",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.contact": "联系我们",
  "scroll.top": "返回顶部",
  "category.all": "全部",
  "article.read_more": "阅读全文",
  "article.related": "相关文章",
  "article.back_to_list": "返回列表",
  "hero.title": "成91平台",
  "hero.subtitle": "备受关注的热门平台，为您带来全新数字化体验",
  "hero.cta": "立即探索",
  "hero.secondary": "了解更多",
  "features.title": "核心功能",
  "features.subtitle": "成91为您提供全方位的平台服务与功能支持",
  "stats.title": "平台数据",
  "stats.users": "累计用户",
  "stats.articles": "优质内容",
  "stats.rating": "用户好评率",
  "stats.partners": "合作伙伴",
  "categories.title": "内容分类",
  "categories.subtitle": "按分类浏览您感兴趣的内容",
  "testimonials.title": "用户评价",
  "testimonials.subtitle": "听听真实用户怎么说",
  "faq.title": "常见问题",
  "faq.subtitle": "关于成91平台的常见问题解答",
  "cta.title": "准备好探索成91了吗？",
  "cta.subtitle": "立即加入成91平台，开启您的全新体验之旅",
  "cta.button": "立即开始",
  "about.title": "关于成91平台",
  "about.intro": "品牌介绍",
  "about.reputation": "平台声誉",
  "about.contact": "联系方式",
  "about.intro_text": "成91是一个备受关注的综合性热门平台，致力于为用户提供优质、便捷的数字化服务。我们汇聚了丰富的资源和专业的服务团队，通过持续创新和技术升级，为用户打造一流的平台体验。",
  "about.reputation_text": "成91平台自上线以来，凭借卓越的服务质量和用户至上的理念，赢得了广大用户的一致好评。我们坚持以用户需求为导向，不断完善平台功能，提升服务品质。",
};
export default common;